import { ButtonHTMLAttributes, Ref } from "react";

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  ref?: Ref<HTMLButtonElement>;
};

/**
 * This is an extension of the standard HTML button.
 * Uses touch-action CSS to ensure proper touch behavior on iOS.
 */
export const Button = ({ ref, ...props }: ButtonProps) => {
  return (
    <button
      {...props}
      ref={ref}
      style={{ WebkitTapHighlightColor: "transparent", touchAction: "manipulation", ...props.style }}
    >
      {props.children}
    </button>
  );
};
